<template>
  <div class="profile">
    <UserDialog />
    <UserEditDialog v-model="formData" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserDialog from './UserDialog.vue'
import UserEditDialog from './UserEditDialog.vue'
export default {
  components: { UserDialog, UserEditDialog },
  data() {
    return {
      loading: false,
      projectId: this.$store.state.user.projectItem.projectId,
      formData: {}
    }
  },
  computed: {
    ...mapState({
      projectList: state => state.user.projectList,
      projectItem: state => state.user.projectItem
    })
  },
  methods: {

  }
}
</script>

<style scoped>
.remoteSearch{
  display: inline-block;
  height: 100%;
  vertical-align: text-bottom;
  padding-top: 2%;
  margin-right: 10px;
}
</style>
